import React from "react";
import { Link } from "../router";
import AssetVisual from "./AssetVisual";

export default function PropertyCard({ p }) {
  return (
    <Link to={`/properties/${p.id}`} className="card reveal" style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ position: "relative", aspectRatio: "4 / 3" }}>
        <div className="media" style={{ position: "absolute", inset: 0 }}>
          <AssetVisual tone={p.tone} accent={p.accent} label={p.assetClass} />
        </div>
        <div style={{ position: "absolute", top: 16, left: 16, display: "flex", gap: 8, flexWrap: "wrap" }}>
          <span className="badge live" style={{ background: "rgba(46,125,82,0.1)", backdropFilter: "blur(8px)", color: "#2E7D52", borderColor: "rgba(46,125,82,0.4)" }}>
            <span className="dot" /> Live · {p.verifiedDays}d ago
          </span>
        </div>
        <div style={{ position: "absolute", top: 16, right: 16 }}>
          <span className="badge" style={{ background: "var(--champagne-ultra)", backdropFilter: "blur(8px)", borderColor: "var(--champagne)" }} title="Aditi Certified Title Check">
            ◈ Title Verified
          </span>
        </div>
      </div>

      <div style={{ padding: "28px 28px 32px", display: "flex", flexDirection: "column", gap: 14, flex: 1 }}>
        <div className="spaced" style={{ gap: 12, flexDirection: "column", alignItems: "flex-start" }}>
          <span className="eyebrow" style={{ fontSize: "0.62rem", letterSpacing: "0.24em" }}>{p.locality}, {p.city}</span>
          {p.construction && <span className="tag">Design + Build</span>}
        </div>
        <h3 className="h-md" style={{ marginBottom: 2 }}>{p.title}</h3>
        <p className="muted" style={{ fontSize: "0.95rem", flex: 1, lineHeight: 1.8 }}>{p.blurb}</p>
        <hr className="rule" style={{ margin: "10px 0 4px" }} />
        <div className="spaced" style={{ flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
          <span style={{ fontFamily: "var(--serif)", fontSize: "1.6rem", color: "var(--ink)", lineHeight: 1 }}>{p.priceLabel}</span>
          <span className="muted" style={{ fontSize: "0.82rem", letterSpacing: "0.04em" }}>
            {p.beds ? `${p.beds} BR · ` : ""}{p.area} {p.areaUnit}
          </span>
        </div>
      </div>
    </Link>
  );
}
